import edit from './edit';
import store from './store';

export default { edit, store };
